import { enumBoxSubTypes } from "../constants";

export function IsRefBox(boxSubType) {
  var refBox =
    boxSubType == enumBoxSubTypes.refBoxTable ||
    boxSubType == enumBoxSubTypes.refBoxLegend ||
    boxSubType == enumBoxSubTypes.refMRBox ||
    boxSubType == enumBoxSubTypes.refChart ||
    boxSubType === enumBoxSubTypes.enumeratedTable;
  return refBox;
}
